import MetaTags from "./components/MetaTags";
import './App.css';
import Home from './components/landingPage/Home';
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Login from "./components/Login";
import "./fonts/BebasNeue-Regular.ttf"

function App() {
  return (
      <Router>
        <div className="App">
            <MetaTags />
               <Routes>
                   <Route path="/" element={<Home />} />
                   <Route path="/login" element={<Login />} />
               </Routes>
        </div>
      </Router>
  );
}

export default App;
